<template>
    <v-dialog v-model="showDialog" width="1200px">
        <v-card>
            <v-card-title class="justify-center">Manual change for {{ item.wzvz_tabel }} {{ item.wzvz_key1_waarde }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <span class="pa-4 text-h6">{{ item.description }} - <b>{{ item.wzvz_veldnaam }}</b></span>
                <v-divider></v-divider>
                <v-textarea class="pa-4" v-model="item.wzvz_veldwaarde_oud"   label="Current valu in database" rows="6" disabled></v-textarea>
                <v-textarea class="pa-4" v-model="item.wzvz_veldwaarde_nieuw" label="Requested by owner/host"  rows="6" disabled></v-textarea>
                <v-divider></v-divider>
                <span class="pa-4">
                    <btn_component type="text" :text="item.button" color="green"  tooltip="Open in a new tab" size="x-small" data="" @actionClick="openTab(item.url)"/>
                </span>
                <v-textarea class="pa-4" v-model="remark" label="remark for completion / decline" rows="3"></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <btn_component type="avatar_icon" icon="mdi-check-circle-outline" color="green"   tooltip="Mark as completed"                      :data="true"  @actionClick="approveDeclineWzvz"/>
                <btn_component type="avatar_icon" icon="mdi-close-circle-outline" color="red"     tooltip="Mark as not completed (declined)"       :data="false" @actionClick="approveDeclineWzvz"/>
                <btn_component type="text"        text="Cancel"                   color="primary" tooltip="Cancel complete/decline" size="x-small"  data=""      @actionClick="closeDialog"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    
    export default {
        components: {
            btn_component,
        },    
        data() {
            return {
                showDialog: false,
                remark: "",
                entity: "",
                entity_key: "",
                item: {
                    wzvz_tabel: "",
                    wzvz_key1_waarde: "",
                    description: ""

                },
            }
        },
        methods: {  
            openDialog(item) {
                this.remark = "";
                this.item = item;
                this.showDialog = true;
            },
            approveDeclineWzvz(approve) {
                this.$emit("approveDeclineWzvz", [this.item.wzvz_encrid], approve, this.remark);
                this.closeDialog();
            },
            openTab(url) {
                this.$router.open(url);
            },
            closeDialog() {
                this.showDialog = false;
            },
        }
    }
</script>

<style scoped> 

</style>